import { Dispatch } from 'types/dispatch';
import { MAINTENANCE_CAMPAIGN_ERROR, MAINTENANCE_CAMPAIGN_SUCCESS } from './status-check.constants';

export const setMaintenanceSuccess = () => ({
    type: MAINTENANCE_CAMPAIGN_SUCCESS
});

export const setMaintenanceError = () => ({
    type: MAINTENANCE_CAMPAIGN_ERROR
});

export const getCampaignStatus = () => {
    return async (dispatch: Dispatch, getState: Function) => {
        const state = getState();

        const status = state.config.maintenanceMode ? setMaintenanceError : setMaintenanceSuccess;
        return dispatch(status());
    };
};
